export function getBusinessPlaceID(business) {
  return business?.google?.placeID || '';
}

export function getGoogleLocationAddress(location) {
  if (isServiceAreaLocation(location))
    return getServiceAreaBusinessAddress(location);

  return getAddressString(location.address);
}

function getAddressString(address) {
  const {
    administrativeArea,
    locality,
    postalCode,
    regionCode
  } = address;

  const addressLines = Array.isArray(address.addressLines) ?
    address.addressLines :
    [];

  const addressParts = [
    ...addressLines,
    locality,
    joinWithSpaces([ administrativeArea, postalCode ])
  ];

  if (regionCode !== 'US')
    addressParts.push(regionCode);

  const addressString = joinWithCommas(addressParts);

  return addressString;
}

function joinWithSpaces(parts) {
  return parts.filter(Boolean).join(' ');
}
function joinWithCommas(parts) {
  return parts.filter(Boolean).join(', ');
}

export function getVerificationAddressString(verifyOption) {
  // verifyOption.addressData has an address property that is the same shape as
  // googleLocation.address
  return getAddressString(verifyOption.addressData.address);
}

export function getGoogleLocationIsVerified(location) {
  return !!location?.locationState?.isVerified;
}

export function getGoogleLocationIsDuplicate(location) {
  return !!location?.locationState?.isDuplicate;
}

export function getGoogleLocationIsDisconnected(location) {
  return !!location?.locationState?.isDisconnected;
}

export function getGoogleLocationPlaceID(location) {
  return location?.locationKey?.placeId;
}

export function isServiceAreaLocation(location) {
  // https://developers.google.com/my-business/reference/rest/v4/accounts.locations#Location.BusinessType
  const businessType = location.serviceArea?.businessType;
  return businessType === 'CUSTOMER_LOCATION_ONLY';
}

function getServiceAreaBusinessAddress(location) {
  try {
    return location.serviceArea.places.placeInfos[0].name;
  } catch (error) {
    return 'No address provided.';
  }
}

export function getBusinessAddressForGoogle(businessAddress) {
  if (!businessAddress)
    return null;

  const { street }      = businessAddress;
  const { city }        = businessAddress;
  const { state }       = businessAddress;
  const { postalCode }  = businessAddress;
  const { countryCode } = businessAddress;

  if (!street || !city || !state || !postalCode || !countryCode)
    return null;

  const address = {
    languageCode: 'en',
    regionCode:   countryCode,
    postalCode,
    addressLines: [
      street,
      [ city, state ].join(', ')
    ]
  };

  return address;
}
